import React, { useMemo, useRef, useState, useEffect } from "react";
import debounce from "lodash/debounce";
import { BiPlus } from "react-icons/bi";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { useNavigate } from "react-router-dom";
import { getinspectionspagedlist, SearchProperty, assignedTo, addinspection,SearchContacts,getpropertiesforinspection,addmultipleinspections,sendemailinspection } from "../../../components/CommonSection/apiresources";
import { GetCookie, currentProfile } from "../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import { dynamicUrl } from "../../../Utilities/profileManagement";
import { Select, Spin, Radio } from "antd";
import CustomModal from "../../input-components/Modal";
import TextBox from "../../input-components/textbox";
import { useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import SelectBox from "../../input-components/selectBoxNew"
import { FormatDate } from "../../../components/CommonSection/Utility/Utility";
import TextArea from '../../input-components/textarea';
import moment from 'moment';
import SubNav from "../../../components/CommonSection/Header/subHeader";
import AntdTableExample from "../../input-components/dataTable";
import { TimePicker, DatePicker, Checkbox } from "antd";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { DeleteOutlined } from '@ant-design/icons';
import CustomButtonDropdown from '../../input-components/customButtonDropdown';
import {DndContext,closestCenter,PointerSensor,useSensor,useSensors} from "@dnd-kit/core";
import {SortableContext,verticalListSortingStrategy,arrayMove,} from "@dnd-kit/sortable";
import SortableItem from "../../input-components/mapSoetable";
import ReactQuill from "react-quill";

import ReactDatePicker from "react-datepicker";

const initialValues = {
    assignedTo: "",
    address: "",
    date: "",
    type: "",
    propertyManager: "",
    startTime: "",
    endTime: "",
    summary: ""
};

const ListInspection = () => {
    const [inspectionLists, setInspectionLists] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [chartData, setChartData] = useState();
    const navigate = useNavigate();
    const ToastRef = useRef();
    const [propertyType, setPropertyType] = useState("All");
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(1);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchValue, setSearchValues] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [openInspection, setOpenInspection] = useState(false);
    const [agencyUniqueID, setAgencyUniqueID] = useState(false);
    const [dpdata, setDpdata] = useState([]);
    const [tenantFolioId, setTenantFolioId] = useState(null);
    const [openPlanInspection, setOpenPlanInspection] = useState(false);
    const currentUser = currentProfile.get();
    const [inspectionMode, setInspectionMode] = useState("multiple"); // or "single"
    const { RangePicker } = DatePicker;
    const [inspectionDueBetween, setInspectionDueBetween] = useState([]);
    const [agreementEndBetween, setAgreementEndBetween] = useState([]);
    const [showNoDueDate, setShowNoDueDate] = useState(false);
    const [selectedProperties, setSelectedProperties] = useState([]); // array of property objects
    const [showPlanningView, setShowPlanningView] = useState(false);
    const [planningStartTime, setPlanningStartTime] = useState(null);
    const [planningDuration, setPlanningDuration] = useState(null);
    const [openAddMsg,setOpenAddMsg] = useState(false)
    const sensors = useSensors(useSensor(PointerSensor));
  const [optionContact, setOptionContact] = useState([]);
    const [agentId, setAgentId] = useState("");
    const [emailLabel, setEmailLabel] = useState("");
    const [propertyManager,setPropertymanager] = useState("");
    const [subject,setSubject] = useState("");
    const [email,setEmail] = useState([]);
    const [emailContent,setEmailContent] = useState("");
    const [selectedValues, setSelectedValues] = useState([]);
  

    const typeOptions = [
        { label: "Rountine", value: 1 },
        { label: "Entry", value: 2 },
        { label: "Exit", value: 3 },
    ];
    const fetchRef = useRef(0);
    const propertyTypeitems = [
        { name: "All", value: null },
        { name: "Sale", value: 1 },
        { name: "Rental", value: 2 },
    ];

    const GOOGLE_MAPS_API_KEY = "AIzaSyBNA6taSRhBuugfKk7MyQQdCVfcz2fJ4tI";

    const mapContainerStyle = {
        width: "100%",
        height: "300px",
        borderRadius: "6px",
        marginTop: "10px",
    };

    const center = {
        lat: -33.865143, // Example: Sydney
        lng: 151.2099,
    };

    // Initialize state
    const [selectedMarkers, setSelectedMarkers] = useState([]);

    const [allProperties, setAllProperties] = useState([]); // Properties from backend with address

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    });


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                    PostApiWithSpinner(parsedData.agencyID, currentUser === 13 ? parsedData.tenantFolioId : null,1)
                    setTenantFolioId(parsedData.tenantFolioId)
                    setAgencyUniqueID(parsedData.agencyUniqueID)
                    setAgentId(parsedData.agentId);

                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId, searchText, searchValue, purpose, propertyType]);

    const reportData = (agencyUID) => {
        const apiUrl = assignedTo;
        const baseUrl = apiUrl + "?agencyUID=" + agencyUID;
        axios.get(baseUrl).then((response) => {
            if (response.data.object) setDpdata(response.data.object);
        });
    };

    const PostApiWithSpinner = (agencyID, tenantid,currentPage) => {
        const baseUrl = getinspectionspagedlist;
        let data = {
            AgencyId: agencyID,
            Search: searchText,
            TenantFolioId: tenantid,
            TabId: purpose,
            PageNo: currentPage,
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    // let propertyData = response.list;
                    const propertyData = response.list || [];
                    let propertyList = propertyData.map((property) => ({
                        Address: property.propertyAddress,
                        InspectionType: property.sInspectionType,
                        InspectionDate: property.inspectionDate ? moment(property.inspectionDate).format("DD-MM-YYYY") : "",
                        ...(purpose !== 2 && {
                            StartTime: moment(property.startTime).format('hh:mm A'),
                            EndTime: moment(property.endTime).format('hh:mm A'),
                            AssignedAgent: property.sAssignedAgent,
                        }),
                        InspectionUniqueId: property.inspectionUniqueId,
                        Status: property.status === 1 ? "Completed" : "Open"
                    }));
                    setInspectionLists(propertyList);
                    setTotalPages(response.totalCount)
                    setChartData(response.object);
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const tabColumns = {
        Status: {
            colorMap: {
                "Completed": "green",
                "Open": "orange",
            },
            defaultColor: 'blue'
        }
    };

    const handleAddAgentClick = () => {
        navigate("/agency/AddInspectionMaster");
    };

    const handleRowClick = (event, rowData) => {
        dynamicUrl(navigate, "ViewInspection" + "?InspectionUniqueId=" + rowData.InspectionUniqueId + '&inspectionType=' + rowData.InspectionType);
    };

    const handlePageChange = (event, pageNumber) => {
        PostApiWithSpinner(agencyID, currentUser === 13 ? tenantFolioId : null,event)
        setCurrentPage(event);
        setFirst(event.first);
        setRows(event.rows);
    };

    const debounceFetcher = useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions([]);
            setFetching(true);
            const baseUrl = SearchProperty;
            const data = {
                Search: value,
                RecordsPerPage: 10,
                PageNo: 1,
            };

            makeRequestWithSpinner(
                showSpinner,
                hideSpinner,
                baseUrl,
                "post",
                data,
                "",
                false
            )
                .then((response) => {
                    if (response.status === 1) {
                        let landingPageListData = response.list;

                        // Transform data to match Select options
                        const transformedData = landingPageListData.map((item) => ({
                            value: item.id,
                            label: item.name,
                        }));

                        // Update options and fetching state
                        if (fetchId === fetchRef.current) {
                            setOptions(transformedData);
                            setFetching(false);
                        }
                    } else {
                        setFetching(false);
                    }
                })
                .catch((error) => {
                    setFetching(false);
                });
        };
        return debounce(loadOptions, 800);
    }, []);

    const handleSearchProperty = (value) => {
        debounceFetcher(value);
        setSearchValues(value.value);
        setFieldValue("address", value.value);
    };

    const handleClearProperty = () => {
        setSearchValues("");
    };

    const handleAddInspection = () => {
        setOpenInspection(true);
        setFieldValue('assignedTo', '')
        setFieldValue('address', '')
        setFieldValue('date', '')
        setFieldValue('type', '')
        setFieldValue('propertyManager', '')
        setFieldValue('startTime', '')
        setFieldValue('endTime', '')
        setFieldValue('summary', '')
        reportData(agencyUniqueID)
    }

    const closeInspection = () => {
        setOpenInspection(false);
    }

    const {
        errors,
        values,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setValues,
        setFieldValue,
    } = useFormik({
        initialValues,
        //validationSchema: PropertyDetailsSchema,
        onSubmit: (values) => {
            handleFinalInspection(values);
        },
    });


    const handleFinalInspection = () => {
        let finalData = {
            CreatedBy: parseInt(userId),
            InspectionType: parseInt(values.type),
            PropertyId: parseInt(values.address),
            InspectionDate: values.date,
            StartTime: values.startTime,
            EndTime: values.endTime,
            Summary: values.summary,
            AssignedAgent: parseInt(values.propertyManager),
            AssignedTo: values.assignedTo,
            AgencyId: parseInt(agencyID)
        }
        if (values.address === "") {
            ToastRef.current.notify(["error", "Property To is required"]);
        } else  if (values.type === "") {
            ToastRef.current.notify(["error", "Type To is required"]);
        }else  if (values.date === "") {
            ToastRef.current.notify(["error", "Date To is required"]);
        }else  if (values.propertyManager === "") {
            ToastRef.current.notify(["error", "Assigned To is required"]);
        } else  if (values.startTime === "") {
            ToastRef.current.notify(["error", "Start Time To is required"]);
        }else  if (values.endTime === "") {
            ToastRef.current.notify(["error", "End Time To is required"]);
        }else {
            const url = addinspection;
            makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData)
                .then((returnData) => {
                    if (returnData.status === ActionStatus.Successfull) {
                        ToastRef.current.notify(["success", returnData.message]);
                        setOpenInspection(false);
                        PostApiWithSpinner(agencyID, currentUser === 13 ? tenantFolioId : null,1);
                    } else {
                        ToastRef.current.notify(["error", returnData.message]);
                    }
                })
                .catch((error) => {
                    ToastRef.current.notify(["error", error.message]);
                });
        }
    };

    const getProperties = async () => {
        return [
            // Area 1: Sydney CBD
            { id: 1, address: "1 George St, Sydney NSW 2000" },
            { id: 2, address: "5 Martin Pl, Sydney NSW 2000" },
            { id: 3, address: "10 Pitt St, Sydney NSW 2000" },
            { id: 4, address: "20 York St, Sydney NSW 2000" },
            { id: 5, address: "25 Kent St, Sydney NSW 2000" },
            { id: 6, address: "30 Sussex St, Sydney NSW 2000" },
            { id: 7, address: "35 Clarence St, Sydney NSW 2000" },
            { id: 8, address: "40 Castlereagh St, Sydney NSW 2000" },
            { id: 9, address: "45 Elizabeth St, Sydney NSW 2000" },
            { id: 10, address: "50 Macquarie St, Sydney NSW 2000" },

            // Area 2: Parramatta
            { id: 11, address: "1 Smith St, Parramatta NSW 2150" },
            { id: 12, address: "5 Church St, Parramatta NSW 2150" },
            { id: 13, address: "10 George St, Parramatta NSW 2150" },
            { id: 14, address: "15 Phillip St, Parramatta NSW 2150" },
            { id: 15, address: "20 Macquarie St, Parramatta NSW 2150" },
        ];
    };



   const handlePlanInspection = async () => {
    setOpenPlanInspection(true);
    setShowPlanningView(false);

    // Clear state
    setSelectedMarkers([]);
    setPlanningStartTime(null);
    setPlanningDuration(null);
    setInspectionDueBetween([]);
    setAgreementEndBetween([]);
    setPropertymanager("");
    setShowNoDueDate(false);
    
    // Reset Formik date field if needed
    setFieldValue("date", "");
    setFieldValue("type","")

    reportData(agencyUniqueID);
};


    const closePlanInspection = () => {
        setOpenPlanInspection(false);
    }


    const fetchGeoProperties = async (addressList) => {
        const geoCoded = await Promise.all(
            addressList.map(async (prop) => {
                try {
                    const response = await fetch(
                        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(prop.address)}&key=${GOOGLE_MAPS_API_KEY}`
                    );
                    const data = await response.json();
                    const location = data.results[0]?.geometry?.location;
                    const suburb = data.results[0]?.address_components?.find((comp) =>
                        comp.types.includes("locality")
                    )?.long_name || "Unknown";
    
                    return {
                        ...prop,
                        lat: location?.lat || 0,
                        lng: location?.lng || 0,
                        suburb,
                    };
                } catch (e) {
                    return {
                        ...prop,
                        lat: 0,
                        lng: 0,
                        suburb: "Unknown",
                    };
                }
            })
        );
        const grouped = geoCoded.reduce((acc, item) => {
            if (item.lat && item.lng && item.lat !== 0 && item.lng !== 0) {
                if (!acc[item.suburb]) acc[item.suburb] = [];
                acc[item.suburb].push(item);
            }
            return acc;
        }, {});
    
        setAllProperties(grouped);
    };
    


    function createNumberIcon(number, color = "#4285F4", textColor = "white") {
        const svg = `
          <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="13" fill="${color}" stroke="white" stroke-width="2"/>
            <text x="15" y="20" text-anchor="middle" font-size="14" fill="${textColor}" font-family="Arial">${number}</text>
          </svg>
        `;
        return {
            url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
            scaledSize: new window.google.maps.Size(30, 30),
        };
    }

    const [yourLocation, setYourLocation] = useState(null);

    const getYourLocation = () => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                setYourLocation({ lat: latitude, lng: longitude });
            },
            (error) => {
                console.error("Geolocation error:", error);
            }
        );
    };


    const handleStatClick = (selectedPurpose) => {
        setPurpose(selectedPurpose);
      };

      const propertyTypeitems1 = [
        { label: "All", value: 0 },
        { label: "Pending", value: 1 },
        { label: "Inspection", value: 2 },
        { label: "Completed", value: -1 },
      ];
      
      const options12 = [
        { label: 'Email to Owner', onClick: (val) => handleAddMsg(val) },
        { label: 'Email to Tenant', onClick: (val) => handleAddMsg(val) },
      ];
      
      const handleAddMsg = (e) => {
        setEmailLabel(e.target.textContent)
        setOpenAddMsg(true)
        setEmail([])
        setEmailContent("")
        setSubject("")
      }

      const handleCancleMsg = (e) => {
        setOpenAddMsg(false)
      } 

      useEffect(() => {
       // calculateChainedDistances();
      }, [yourLocation, selectedMarkers.length]);
      
      
      const roundTravelTime = (minutes) => {
        if (minutes <= 10) return 15;
        if (minutes <= 15) return 20;
        if (minutes <= 20) return 25;
        if (minutes <= 25) return 30;
        if (minutes <= 30) return 35;
        if (minutes <= 35) return 40;
        if (minutes <= 40) return 45;
        if (minutes <= 45) return 50;
        if (minutes <= 50) return 55;
        if (minutes <= 55) return 60;
        return 60;
      };
      
      const recalculateSchedule = (markers, startMoment) => {
        if (!startMoment || !planningDuration || markers.length === 0) return markers;
      
        const updated = [];
        let timePointer = startMoment.clone();
        markers.forEach((marker, index) => {
          const durationStr = marker.durationText?.split(" ")[0];
          const durationNum = parseInt(durationStr || "0", 10);
          const travelTime = roundTravelTime(durationNum);
          timePointer = timePointer.clone().add(travelTime, "minutes");
          const inspectionStart = timePointer.clone();
          const inspectionEnd = inspectionStart.clone().add(planningDuration, "minutes");
            updated.push({
                ...marker,
                inspectionStart: inspectionStart.toISOString(),
                inspectionEnd: inspectionEnd.toISOString(),
            });

      
          timePointer = inspectionEnd.clone();
        });
      
        return updated;
      };
      
      useEffect(() => {
        if (planningStartTime  && selectedMarkers.length > 0) {
          const updated = recalculateSchedule(selectedMarkers, moment(planningStartTime, "HH:mm"));
          setSelectedMarkers(updated);
        }
      }, [planningStartTime, selectedMarkers.length]);

      
      const handleSearchLocation = async (query) => {
        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=${GOOGLE_MAPS_API_KEY}`
          );
          const data = await response.json();
          const location = data.results[0]?.geometry?.location;
          if (location) {
            setYourLocation({ lat: location.lat, lng: location.lng });
            ToastRef.current?.notify?.(["success", "Location set successfully"]);
          } else {
            ToastRef.current?.notify?.(["error", "Location not found"]);
          }
        } catch (err) {
          ToastRef.current?.notify?.(["error", "Failed to search location"]);
        }
      };
      

    //   const calculateChainedDistances = (markers = selectedMarkers) => {
    //     if (!yourLocation || markers.length === 0 || !window.google?.maps) return;
      
    //     const service = new window.google.maps.DistanceMatrixService();
    //     const origins = [yourLocation, ...markers.slice(0, -1).map(p => ({ lat: p.lat, lng: p.lng }))];
    //     const destinations = markers.map(p => ({ lat: p.lat, lng: p.lng }));
      
    //     service.getDistanceMatrix(
    //       {
    //         origins: origins.map(o => new window.google.maps.LatLng(o.lat, o.lng)),
    //         destinations: destinations.map(d => new window.google.maps.LatLng(d.lat, d.lng)),
    //         travelMode: window.google.maps.TravelMode.DRIVING,
    //         unitSystem: window.google.maps.UnitSystem.METRIC,
    //       },
    //       (response, status) => {
    //         if (status === "OK") {
    //           const updated = markers.map((marker, i) => {
    //             const element = response.rows[i]?.elements[i];
    //             return {
    //               ...marker,
    //               distanceText: element?.distance?.text || "N/A",
    //               durationText: element?.duration?.text || "N/A",
    //             };
    //           });
      
    //           const recalculated = recalculateSchedule(updated, planningStartTime);
    //           setSelectedMarkers(recalculated);
    //         } else {
    //           console.error("Distance matrix error:", status);
    //         }
    //       }
    //     );
    //   };
      
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
          const oldIndex = selectedMarkers.findIndex((p) => (p.id || p.lat + "-" + p.lng).toString() === active.id);
          const newIndex = selectedMarkers.findIndex((p) => (p.id || p.lat + "-" + p.lng).toString() === over.id);
          const reordered = arrayMove(selectedMarkers, oldIndex, newIndex);
      
          setSelectedMarkers(reordered);
          const recalculated = recalculateSchedule(reordered, planningStartTime);
          setSelectedMarkers(recalculated);
        }
      };


       useEffect(() => {
          agentUIDRef.current = agentId;
        }, [agentId]);
      
        const agentUIDRef = useRef(agentId);
      
        const debounceFetcherContact = useMemo(() => {
          const loadOptions = (value) => {
            setOptionContact([]);
            setFetching(true);
            let data = {
              Search: value,
              RecordsPerPage: 10,
              PageNo: 1,
              AgentID: agentUIDRef.current,
            };
      
            makeRequestWithSpinner(
              showSpinner,
              hideSpinner,
              SearchContacts,
              "post",
              data
            )
              .then((response) => {
                const transformedData = response.list.map((item) => ({
                  value: item.id,
                  label: item.name,
                  uid: item.uid,
                  email: item.email
                }));
                setOptionContact(transformedData);
                setFetching(false);
              })
              .catch((error) => setFetching(false));
          };
      
          return debounce(loadOptions, 800); // Debounce time of 800ms
        }, []);
      
        const handleSearchChange = (e, value, index) => {
          if (value.length > 0) {
            const emailArray = value.map(v => v?.email);
            setEmail(emailArray);
            debounceFetcherContact(value);
          }
        };
      

        const handlePropertiesforinspection = async (dates = inspectionDueBetween) => {
            if (!dates || dates.length < 2) return;
        
            const [from, to] = dates;
            const finalData = {
                //InspectionDueFrom: moment(from).format("YYYY-MM-DD"),
                //InspectionDueTo: moment(to).format("YYYY-MM-DD"),
                AgencyId: parseInt(agencyID)
            };
        
        
            try {
                const returnData = await makeRequestWithSpinner(showSpinner, hideSpinner, getpropertiesforinspection, "post", finalData);
                if (returnData.status === ActionStatus.Successfull) {
                    await fetchGeoProperties(returnData.list); // Make sure they have an address field

                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            } catch (error) {
                ToastRef.current.notify(["error", error.message]);
            }
        };
        

    const handleSchedule = async () => {
        // Ensure `values.date` is a valid moment-compatible value
        const inspectionMoment = moment(values.date);
        if (!inspectionMoment.isValid()) {
            ToastRef.current.notify(["error", "Please select a valid inspection date."]);
            return;
        }

        const formattedDate = inspectionMoment.format("YYYY-MM-DD");
        const propertyDetails = selectedMarkers.map((marker) => {
            const startTime = moment(marker.inspectionStart);
            const endTime = moment(marker.inspectionEnd);


            return {
                PropertyId: marker.id,
                StartTime: startTime.isValid()
                    ? `${formattedDate}T${startTime.format("HH:mm")}:00`
                    : null,
                EndTime: endTime.isValid()
                    ? `${formattedDate}T${endTime.format("HH:mm")}:00`
                    : null,
            };
        });

        const invalidTimeEntry = propertyDetails.some(
            (item) => !item.StartTime || !item.EndTime
        );

        if (invalidTimeEntry) {
            ToastRef.current.notify(["error", "Some properties have invalid start/end times."]);
            return;
        }

        const finalData = {
            InspectionType: parseInt(values.type),
            InspectionDate: `${formattedDate}T00:00:00`,
            AssignedAgent: parseInt(propertyManager),
            AgencyId: parseInt(agencyID),
            PropertyDetails: propertyDetails,
        };

        try {
            const returnData = await makeRequestWithSpinner(
                showSpinner,
                hideSpinner,
                addmultipleinspections,
                "post",
                finalData
            );

            if (returnData.status === ActionStatus.Successfull) {
                ToastRef.current.notify(["success", "Inspections scheduled successfully"]);
                closePlanInspection();
                PostApiWithSpinner(agencyID, currentUser === 13 ? tenantFolioId : null,1);
            } else {
                ToastRef.current.notify(["error", returnData.message]);
            }
        } catch (error) {
            ToastRef.current.notify(["error", error.message]);
        }
    };

          
          const handleSendMail = () => {
            let finalData = {
                Emails : email,
                BodyEmail : emailContent,
                Subject : subject,
            }
            if (email === "") {
                ToastRef.current.notify(["error", "Email is required"]);
            } else {
                const url = sendemailinspection;
                makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData)
                    .then((returnData) => {
                        if (returnData.status === ActionStatus.Successfull) {
                            ToastRef.current.notify(["success", returnData.message]);
                            setOpenAddMsg(false);
                        } else {
                            ToastRef.current.notify(["error", returnData.message]);
                        }
                    })
                    .catch((error) => {
                        ToastRef.current.notify(["error", error.message]);
                    });
            }
        };

    const handleStartPlanning = () => {
        if (!values.type) {
            ToastRef.current.notify(["error", "Report Type is required."]);
            return;
        }

        if (!values.date) {
            ToastRef.current.notify(["error", "Inspection Due Between is required."]);
            return;
        }

        // continue with planning
        setShowPlanningView(true);
    };


    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav
                        title={"Inspection"}
                        actionButton={false}
                        extraData={true}
                        goback={false}
                        extraContent={
                            <div>
                                <button className="tab-btn-inspection mr-1" onClick={handleAddAgentClick}>
                                    <div className="text-parent">
                                        <div style={{ fontSize: "14px", whiteSpace: 'nowrap' }}>1 Agent Overdue</div>
                                    </div>
                                </button>
                                <CustomButtonDropdown buttonLabel="Add Message" options={options12} />
                                <button className="ml-1 Add-Property-button" onClick={handlePlanInspection}>
                                    <div className="text-parent">
                                        <div style={{ fontSize: "14px", whiteSpace: 'nowrap' }}>Plan Inspection</div>
                                    </div>
                                </button>
                                <button className="Add-Property-button" onClick={handleAddInspection} >
                                    <div className="text-parent">
                                        <div  style={{ fontSize: "14px" }}>Add Inspection</div>
                                    </div>
                                </button>
                                {/* <button
                                            className="Add-Property-button"
                                            type="submit"
                                            onClick={handleAddAgentClick}
                                        >
                                            <div className="text-parent">
                                                <BiPlus style={{ width: "25px", height: "25px" }} />
                                                <div className="text7" style={{ fontSize: "14px" }}>
                                                    Add Master
                                                </div>
                                            </div>
                                        </button> */}
                               
                            </div>
                        }

                    />
                    <div className="material-work-desk-new bg-white m-3">
                        <ToastAlert ref={ToastRef} />
                        {/* <div style={{ margin: '10px' }}>
                            <Select
                                style={{ width: 300 }}
                                className="landingPageSearchs mr-2"
                                mode="single"
                                showSearch
                                placeholder="Search for Property"
                                labelInValue
                                filterOption={false}
                                onSearch={debounceFetcher}
                                notFoundContent={fetching ? <Spin size="small" /> : null}
                                options={options}
                                onChange={handleSearchProperty}
                                allowClear
                                onClear={handleClearProperty}
                            />

                        </div> */}
                        <div style={{ borderBottom: '1px solid #e9ecef', padding: '10px' }}>
                            <div >
                            <span
                                    className={`tabwidth stat-item ${purpose ===1 ? 'active' : ''}`}
                                    onClick={() => handleStatClick(1)}
                                >
                                    Scheduled 
                                </span>
                           
                                <span
                                    className={`tabwidth stat-item ${purpose === 2 ? 'active' : ''}`}
                                    onClick={() => handleStatClick(2)}
                                >
                                    Unscheduled
                                </span>
                              
                                <span
                                    className={`tabwidth stat-item ${purpose ===  3? 'active' : ''}`}
                                    onClick={() => handleStatClick(3)}
                                >
                                    Inspected
                                </span>
                                <span
                                    className={`tabwidth stat-item ${purpose ===  4? 'active' : ''}`}
                                    onClick={() => handleStatClick(4)}
                                >
                                    Assigned
                                </span>
                                <span
                                    className={`tabwidth stat-item ${purpose ===  5? 'active' : ''}`}
                                    onClick={() => handleStatClick(5)}
                                >
                                    Returned
                                </span>
                                <span
                                    className={`tabwidth stat-item ${purpose ===  6? 'active' : ''}`}
                                    onClick={() => handleStatClick(6)}
                                >
                                    Closed
                                </span>
                            </div>
                        </div>
                          <div style={{ float: 'right', margin: '10px' }}><Select  value={propertyType} style={{ width: 120 }} options={propertyTypeitems1} /></div>
                        <AntdTableExample
                            label="List Inspection"
                            dataSource={inspectionLists}
                            globalSearch
                            hideCol={"InspectionUniqueId"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            totalRecords={totalPages}
                            onRowClick={handleRowClick}
                            tagColumns={tabColumns}
                        />

                        <CustomModal
                            title="Add Inspection"
                            width={650}
                            closable={closeInspection}
                            visible={openInspection}
                            onCancel={closeInspection}
                            modalData={
                                <div className="row" style={{ marginTop: "30px", marginLeft: "10px" }}>
                                    <div className={`lda-${name} col-lg-6 col-sm-12`}>
                                        <label className="s1">
                                            Property <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div>
                                            <Select
                                                style={{ width: '100%', height: '40px' }}
                                                className="landingPageSearchs"
                                                mode="single"
                                                showSearch
                                                placeholder="Search for Property"
                                                labelInValue
                                                filterOption={false}
                                                onSearch={debounceFetcher}
                                                notFoundContent={fetching ? <Spin size="small" /> : null}
                                                options={options}
                                                onChange={handleSearchProperty}
                                                allowClear
                                                onClear={handleClearProperty}
                                            />
                                            {errors.address && touched.address ? (
                                                <p className="form-error">{errors.address}</p>
                                            ) : null}
                                        </div>
                                    </div>
                                    <SelectBox
                                        isMandatory
                                        label="Type"
                                        name="type"
                                        options={typeOptions}
                                        value={values.type}
                                        onChange={(val) => setFieldValue("type", val.value)}
                                    />
                                    <TextBox
                                        label="Date"
                                        isMandatory
                                        type="date"
                                        name="date"
                                        placeholder="dd/mm/yyyy"
                                        value={FormatDate(values.date)}
                                        onChange={(e) => setFieldValue("date", e.target.value)}
                                        onBlur={handleBlur}
                                        error={errors.date}
                                        touched={touched.date}
                                    />
                                    <div className="cda-reportTo col-lg-6 col-sm-12">
                                        <label htmlFor="propertyManager" className="s1 w-100">
                                            Assigned To<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <Dropdown
                                            value={values.propertyManager}
                                            onChange={(e) => setFieldValue("propertyManager", e.value)}
                                            options={dpdata}
                                            optionLabel="text"
                                            className="w-100 md:w-14rem"
                                            placeholder="Assigned To"
                                            style={{
                                                width: "100%",
                                                height: "40px",
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        />
                                        {errors.propertyManager && touched.propertyManager && (
                                            <p className="form-error">{errors.propertyManager}</p>
                                        )}
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <label className="s1">Start Time <span style={{color:'red'}}>*</span></label>
                                        <ReactDatePicker
                                            selected={values.startTime ? moment(values.startTime, 'HH:mm').toDate() : null}
                                            onChange={(time) => {
                                                const formattedTime = moment(time).format("HH:mm");
                                                setFieldValue("startTime", formattedTime);

                                                // Validate end time (reset if invalid)
                                                if (
                                                    values.endTime &&
                                                    moment(formattedTime, "HH:mm")
                                                        .add(15, "minutes")
                                                        .isAfter(moment(values.endTime, "HH:mm"))
                                                ) {
                                                    setFieldValue("endTime", "");
                                                    ToastRef.current?.notify?.(["error", "End time must be at least 15 minutes after start time"]);
                                                }
                                            }}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            dateFormat="h:mm aa"
                                            placeholderText="Select start time"
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="col-lg-6 col-sm-12">
                                        <label className="s1">End Time <span style={{color:'red'}}>*</span></label>
                                        <ReactDatePicker
                                            selected={values.endTime ? moment(values.endTime, 'HH:mm').toDate() : null}
                                            onChange={(time) => {
                                                const start = moment(values.startTime, "HH:mm");
                                                const end = moment(time);

                                                if (start.isValid() && end.isBefore(start.clone().add(15, "minutes"))) {
                                                    ToastRef.current?.notify?.(["error", "End time must be at least 15 minutes after start time"]);
                                                } else {
                                                    setFieldValue("endTime", moment(time).format("HH:mm"));
                                                }
                                            }}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            dateFormat="h:mm aa"
                                            placeholderText="Select end time"
                                            className="form-control"
                                        />
                                    </div>


                                    <TextArea value={values.summary} name="summary" label="Summary" error={errors.summary} touched={touched.summary} onChange={(e) => setFieldValue("summary", e.target.value)} />
                                </div>
                            }
                            footer={[
                                <div
                                    key="footer"
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <button
                                        style={{ marginRight: "20px" }}
                                        className="pdb-save-changes mt-2"
                                        onClick={handleFinalInspection}
                                    >
                                        Submit
                                    </button>
                                </div>,
                            ]}
                        />

                        <CustomModal
                            title="Plan Inspections"
                            width={800}
                            closable={closePlanInspection}
                            visible={openPlanInspection}
                            onCancel={closePlanInspection}
                            modalData={
                                <div className="row" style={{ marginTop: "20px", marginLeft: "10px" }}>
                                    <>
                                        {/* Report Type & Date */}
                                        {!showPlanningView && (
                                            <div>
                                                <div className="pl-2 pr-2 row">
                                                    <SelectBox
                                                        isMandatory
                                                        label="Report Type"
                                                        name="type"
                                                        options={typeOptions}
                                                        value={values.type}
                                                        onChange={(val) => setFieldValue("type", val.value)}
                                                    />
                                                      <div className="pl-4 col-lg-6 col-sm-12 mb-3">
                                                                <label className="s1">Inspection Due Between<span style={{color:'red'}}>*</span></label>
                                                    <DatePicker
                                                        style={{ width: "100%", height:'35px' }}
                                                        format="DD/MM/YYYY"
                                                        placeholder="Select inspection date"
                                                        value={values.date ? moment(values.date) : null}
                                                        onChange={(date) => setFieldValue("date", date)}
                                                        onBlur={handleBlur}
                                                            disabledDate={(current) => {
                                                                // Allow only dates from 7 days in the future onwards
                                                                const minDate = moment().add(7, 'days').startOf('day');
                                                                return current && current < minDate;
                                                            }}
                                                    />
                                                        </div>
                                                </div>

                                                <div className="pl-2 pr-2">
                                                    <div style={{ border: '1px solid #cccccc', borderRadius: '4px' }}>
                                                        <div className="cda-reportTo col-lg-6 col-sm-12">
                                                            <label htmlFor="propertyManager" className="s1 w-100">
                                                            Property Manager or Team
                                                            </label>
                                                            <Dropdown
                                                                value={propertyManager}
                                                                onChange={(e) => setPropertymanager(e.value)}
                                                                options={dpdata}
                                                                optionLabel="text"
                                                                className="w-100 md:w-14rem"
                                                                placeholder="Assigned To"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "40px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="mt-3 col-lg-12 col-sm-12 mb-3 d-flex align-items-end">
                                                            <Checkbox
                                                                checked={showNoDueDate} // You can manage this state with useState
                                                                onChange={(e) => setShowNoDueDate(e.target.checked)}
                                                            >
                                                                Show properties with no due inspection date set
                                                            </Checkbox>
                                                        </div>
                                                        <div className="row">
                                                            <div className="pl-4 col-lg-6 col-sm-12 mb-3">
                                                                <label className="s1">Inspection Due Between</label>
                                                                <RangePicker
                                                                    style={{ width: "100%" }}
                                                                    onChange={(dates) => {
                                                                        setInspectionDueBetween(dates); // Keep raw Moment values
                                                                        if (dates && dates.length === 2) {
                                                                            handlePropertiesforinspection(dates); // Pass explicitly
                                                                        }
                                                                    }}
                                                                    value={inspectionDueBetween}
                                                                    format="DD/MM/YYYY"
                                                                />
                                                            </div>

                                                            <div className="pr-4 col-lg-6 col-sm-12 mb-3">
                                                                <label className="s1">Agreement Ending Between</label>
                                                                <RangePicker
                                                                    style={{ width: "100%" }}
                                                                    onChange={(dates) => setAgreementEndBetween(dates)}
                                                                    value={agreementEndBetween}
                                                                    format="DD/MM/YYYY"
                                                                />
                                                            </div>
                                                            <div className="pl-4 pr-4 col-12 mt-3">
                                                                <label className="s1 mb-2">Click properties on the map to select them.</label>

                                                                {isLoaded ? (
                                                                    <GoogleMap
                                                                        mapContainerStyle={mapContainerStyle}
                                                                        zoom={11}
                                                                        center={center}
                                                                        onClick={async (e) => {
                                                                            const lat = e.latLng.lat();
                                                                            const lng = e.latLng.lng();

                                                                            const response = await fetch(
                                                                                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
                                                                            );
                                                                            const data = await response.json();
                                                                            const address = data.results?.[0]?.formatted_address || "Unknown address";

                                                                            setSelectedMarkers((prev) => [
                                                                                ...prev,
                                                                                { lat, lng, address }
                                                                            ]);
                                                                        }}


                                                                    >
                                                                        {Object.entries(allProperties).map(([suburb, props], index) => {
                                                                            const avgLat = props.reduce((sum, p) => sum + p.lat, 0) / props.length;
                                                                            const avgLng = props.reduce((sum, p) => sum + p.lng, 0) / props.length;

                                                                            return (
                                                                                <Marker
                                                                                    key={suburb}
                                                                                    position={{ lat: avgLat, lng: avgLng }}
                                                                                    icon={createNumberIcon(props.length)}
                                                                                    onClick={() => {
                                                                                        // Filter out already added addresses
                                                                                        const existingIds = new Set(selectedMarkers.map(p => p.id));
                                                                                        const newOnes = props.filter(p => !existingIds.has(p.id));

                                                                                        // Append new unique ones
                                                                                        setSelectedMarkers((prev) => [...prev, ...newOnes]);
                                                                                    }}

                                                                                />
                                                                            );
                                                                        })}


                                                                    </GoogleMap>

                                                                ) : (
                                                                    <Spin />
                                                                )}
                                                            </div>

                                                            <div className="pl-4 pr-4 col-12 mt-3">
                                                                <label className="s1 mb-2">Selected Properties</label>
                                                                <Select
                                                                    mode="tags"
                                                                    style={{ width: "100%" }}
                                                                    placeholder="Selected Properties"
                                                                    value={selectedMarkers.map((p) => p.address)}
                                                                    onChange={(values) => {
                                                                        const updated = selectedMarkers.filter((p) =>
                                                                            values.includes(p.address)
                                                                        );
                                                                        setSelectedMarkers(updated);
                                                                    }}
                                                                    open={false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>)}
                                        {showPlanningView && (
                                            <div className="plan-inspection-container">

                                                {/* Schedule Controls */}
                                                <div className="schedule-controls d-flex mb-3">
                                                    <ReactDatePicker
                                                        selected={planningStartTime ? moment(planningStartTime, 'HH:mm').toDate() : null}
                                                        onChange={(time) => {
                                                            const formattedTime = moment(time).format("HH:mm");
                                                            setPlanningStartTime(formattedTime);

                                                         
                                                        }}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select start time"
                                                        className="form-control"
                                                        wrapperClassName="d-inline-block"
                                                        popperPlacement="bottom-start"
                                                    />
                                                    <Select
                                                        placeholder="Select duration"
                                                        style={{ width: 200, marginLeft: 12, height:'35px' }}
                                                        options={[
                                                            { label: "15 min", value: 15 },
                                                            { label: "30 min", value: 30 },
                                                            { label: "45 min", value: 45 },
                                                            { label: "60 min", value: 60 },
                                                        ]}
                                                        value={planningDuration}
                                                        onChange={(val) => setPlanningDuration(val)}
                                                    />

                                                </div>

                                                {/* Google Map */}
                                                <div style={{ borderRadius: 8, overflow: 'hidden', height: 350 }}>
                                                    <GoogleMap
                                                        mapContainerStyle={mapContainerStyle}
                                                        zoom={11}
                                                        center={center}
                                                    >
                                                        {selectedMarkers.map((marker, index) => (
                                                            <Marker
                                                                key={`${marker.lat}-${marker.lng}`}
                                                                position={{ lat: marker.lat, lng: marker.lng }}
                                                                icon={createNumberIcon(index + 1)}
                                                            />
                                                        ))}
                                                    </GoogleMap>
                                                </div>

                                                {/* Schedule List */}
                                                <DndContext
                                                    sensors={sensors}
                                                    collisionDetection={closestCenter}
                                                    onDragEnd={handleDragEnd}
                                                >
                                                    <SortableContext
                                                        items={selectedMarkers.map((p) => String(p.id || `${p.lat}-${p.lng}`))}
                                                        strategy={verticalListSortingStrategy}
                                                    >
                                                        <div className="schedule-list mt-3">
                                                            {selectedMarkers.map((property, index) => (
                                                                <SortableItem
                                                                    key={property.id}
                                                                    id={String(property.id || `${property.lat}-${property.lng}`)}
                                                                    index={index}
                                                                    property={property}
                                                                    onDelete={(toRemove) =>
                                                                        setSelectedMarkers((prev) =>
                                                                            prev.filter((p) => p.id !== toRemove.id)
                                                                        )
                                                                    }

                                                                />

                                                            ))}
                                                        </div>
                                                    </SortableContext>
                                                </DndContext>

                                            </div>
                                        )}
                                    </>
                                </div>
                            }
                            footer={[
                                <div key="footer" style={{ display: "flex", justifyContent: "flex-end" }}>
                                    {!showPlanningView && (
                                        <>
                                            <button className="pdb-cancel me-2" onClick={closePlanInspection}>
                                                Cancel
                                            </button>
                                            <button className="Add-Property-button" onClick={handleStartPlanning}>
                                                Start Planning
                                            </button>
                                        </>
                                    )}

                                    {showPlanningView && (
                                        <>
                                            <button className="pdb-cancel me-2" onClick={() => setShowPlanningView(false)}>
                                                Back
                                            </button>
                                            <button className="Add-Property-button" onClick={handleSchedule}>
                                                Schedule
                                            </button>
                                        </>
                                    )}
                                </div>
                            ]}
                        />


                        <CustomModal
                            title={emailLabel}
                            width={600}
                            closable={handleCancleMsg}
                            visible={openAddMsg}
                            onCancel={handleCancleMsg}
                            modalData={
                                <div className="row" style={{ marginTop: "20px", marginLeft: "10px" }}>
                                    <div className="pl-2 pr-2 row">
                                        <div className="col-lg-12 col-sm-12">
                                            <label className="s1">{emailLabel === "Email to Owner" ? "Owner" : "Tenant"}</label>
                                            <div style={{ display: "flex" }}>
                                                <Select
                                                    style={{ width: "100%", height: "auto" }}
                                                    placeholder="Search for contacts"
                                                    labelInValue
                                                    showSearch
                                                    filterOption={false}
                                                    onSearch={debounceFetcherContact}
                                                    notFoundContent={
                                                        fetching ? <Spin size="small" /> : null
                                                    }
                                                    options={optionContact}
                                                    onChange={(label, value) =>
                                                        handleSearchChange(label, value)
                                                    }
                                                    defaultValue={selectedValues}
                                                    allowClear
                                                    mode="multiple"
                                                />
                                            </div>
                                        </div>
                                        <TextBox colVal={12} value={subject} label="Subject" name="subject" onChange={(e) => setSubject(e.target.value)}/>
                                       <div className="mt-2">
                                       <label htmlFor="lnumber" className="s1">
                                            Description<span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <div className="input-group mb-3">
                                            <ReactQuill
                                                className="w-100 d-flex flex-column"
                                                theme="snow"
                                                value={emailContent}
                                                onChange={(val) => setEmailContent(val)}
                                            />
                                        </div>
                                       </div>
                                    </div>
                                </div>
                            }
                            footer={[
                                <div className="mt-2" key="footer" style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button className="pdb-cancel me-2" onClick={() => handleCancleMsg()}>
                                        Cancel
                                    </button>
                                    <button className="Add-Property-button" onClick={handleSendMail}>
                                        Submit
                                    </button>
                                </div>
                            ]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListInspection;
